import React from 'react';

const SearchResults = ({ results, onSelect }) => {
  if (!results || results.length === 0) {
    return <div className="search-results">No results</div>;
  }

  return (
    <div className="search-results">
      <ul>
        {results.map((item) => (
          <li key={item.id} onClick={() => onSelect && onSelect(item)}>
            {item.data && item.data.use_case && item.data.use_case.title
              ? item.data.use_case.title
              : `ID: ${item.id}`}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchResults;

